import React, { useEffect } from "react";
import {Box} from "@mui/material";
import CheckboxController from "../../../../components/CheckboxSelector/CheckboxSelector";
import { foot_point_options } from "./formFootOptions";

const LeftLegPoints = (props)=>{
  const { control, errors } = props;
  return (
    <>
      <Box sx={{ position: "absolute", width:"1%", top: "75px" ,left: "118px" }}>
        <CheckboxController
          name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
                                options={foot_point_options.foot_point_1_options}


          />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "88px" ,left: "150px" }}>
        <CheckboxController
         name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_2_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "116px" ,left: "175px" }}>
        <CheckboxController
        name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_3_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "127px" ,left: "105px" }}>
        <CheckboxController
       name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_4_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "115px" ,left: "138px" }}>
        <CheckboxController
        name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_5_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "149px" ,left: "162px" }}>
        <CheckboxController
        name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_6_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "198px" ,left: "125px" }}>
        <CheckboxController
         name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_7_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "212px" ,left: "152px" }}>
        <CheckboxController
         name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_8_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "291px" ,left: "118px" }}>
        <CheckboxController
         name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_9_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "52px", left: "58px" }}>
        <CheckboxController
         name={"foot_sensation_diag_left"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_10_options}
           />
      </Box>
    </>
  );
};

const RightLegPoints = (props)=>{
  const { control, errors } = props;
  return (
    <>
      <Box sx={{ position: "absolute", width:"1%", top: "77px" ,left: "310px" }}>
      <CheckboxController
          name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                options={foot_point_options.foot_point_1_options}


          />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "88px" ,left: "275px" }}>
        <CheckboxController
         name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_2_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "117px" ,left: "255px" }}>
        <CheckboxController
        name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_3_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "130px" ,left: "325px" }}>
        <CheckboxController
          name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_4_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "116px" ,left: "289px" }}>
        <CheckboxController
          name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_5_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "150px" ,left: "262px" }}>
        <CheckboxController
          name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_6_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "199px" ,left: "300px" }}>
        <CheckboxController
           name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_7_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "213px" ,left: "272px" }}>
        <CheckboxController
         name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_8_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "292px" ,left: "304px"  }}>
        <CheckboxController
         name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_9_options}
           />
      </Box>

      <Box sx={{ position: "absolute", width:"1%", top: "54px", left: "370px" }}>
        <CheckboxController
        name={"foot_sensation_diag_right"}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                isHorizantalPadding={false}
                                isDisabled
                                isCustomColorForFoot={true}
                                isMarginLeft={true}
                                specialTick={true}
          options={foot_point_options.foot_point_10_options}
           />
      </Box>
    </>
  );
};

const FootImageComp = (props) => {
  const { control, errors, watch, getValues } = props;

  return (
    <>
      <Box sx={{ position: "relative", overflow: "auto", mb: "1rem" }}>
        <figure>
          <Box component="img" src={"/assets/images/footImage.png"} alt="Ministry of Health Logo" style={{ minWidth: "450px", minHeight: "350px",  maxWidth: "450px", maxHeight: "350px" }}/>
          <LeftLegPoints control={control} errors={errors} />
          <RightLegPoints control={control} errors={errors} />
          <Box component="figcaption" sx={{ fontSize: "20px" }}>10g Monofilament – <span style={{ fontWeight: "bold" }}>Mark with An ‘X’ area where sensation is lost or diminished
            <br/>{`Score R [${getValues("foot_sensation_diag_right_select")}/10] L [${getValues("foot_sensation_diag_left_select")}/10]`}</span></Box>
        </figure>
      </Box>
    </>
  );
};

export default FootImageComp;